<template>
<div class="result-win-wrap">
  <modal :showstate = showstate @close="closeModal">
    <div slot="text" class="win-modal-box">
      <!-- 实物中奖 -->
      <div v-if="resultdata.bonus_type == 'custom'">
        <div class="top-img win-img-bj">
          <img :src="resultdata.img_win" alt="">
        </div>
        <div class="title">中奖啦</div>
        <div class="prize-name">恭喜获得<span>{{resultdata.bonus_desc}}</span></div>
        <div class="des">请前往【我的】-我的奖品{{resultdata.is_delivery && resultdata.is_delivery == 'on'?'填写收货地址':'查看'}}</div>
        <div class="gobtn" @click="goMyPrize">{{resultdata.is_delivery && resultdata.is_delivery == 'on'?'去填写':'去查看'}}</div>
      </div>

      <!-- 未中奖 -->
      <div v-if="resultdata.bonus_type == 'none'">
        <div class="top-img">
          <img src="../../assets/images/not-win-icon@2x-v1.png" alt="">
        </div>
        <div class="title no-win-title">谢谢参与</div>
        <div class="des">别灰心，还有机会哦~~</div>
        <!-- <div class="prize-name">{{resultdata.bonus_desc}}<span></span></div> -->
      </div>
      <!-- 积分奖 -->
      <div v-if="resultdata.bonus_type == 'point'">
        <div class="top-img">
          <img src="../../assets/images/integral-img@2x.png" alt="">
        </div>
        <div class="title">中奖啦</div>
        <div class="prize-name">恭喜获得<span>{{resultdata.num}}积分</span></div>
        <div class="des">请前往【我的】-我的奖品查看</div>
        <div class="gobtn" @click="goCoin">去查看</div>
      </div>
    </div>
  </modal>
</div>
</template>
<script>
import { agent } from '@/utils';
import modal from '../modal/modal';

export default {
  name: 'resultModal',
  components: {
    modal,
  },
  props: {
    showstate: {
      type: Boolean,
      default: false,
    },
    resultdata: {
      type: Object || String,
      default: {},
    },
  },
  methods: {
    closeModal() {
      this.$emit('closeResult');
    },
    // 积分列表
    goMyPrize() {
      this.closeModal();
      if (agent === 'native') {
        window.openWebView(`${process.env.VUE_APP_BASE_URL_PMALL}/mgwap/prize-list.html`);
      } else {
        wx.miniProgram.navigateTo({
          url: '/pages/prize/prize',
        });
      }
    },
    // 奖品列表
    goCoin() {
      if (agent === 'native') {
        window.openWebView(`${process.env.VUE_APP_BASE_URL_PMALL}/mgwap/prize-list.html`);
      } else {
        wx.miniProgram.navigateTo({
          url: '/pages/coin/coin',
        });
      }
    },
  },
};
</script>
<style lang="stylus">
.result-win-wrap{
  .win-modal-box{
    .top-img{
      height: 176px;
      background-size:cover;
      &.win-img-bj{
        background: url(../../assets/images/prize-bj@2x.png) no-repeat 0 0;
      }
      img{
        width:100%;
        height: 100%;
      }
    }
    .title{
      font-size: 17px;
      padding-bottom 14px
    }
    .no-win-title{
      margin-top: 50px;
    }
    .prize-name,.des{
      font-size: 14px;
      color: #6D7278;
      line-height: 24px;
      span{
        color: #000;
        margin-left: 5px;
      }
    }
    .prize-name{
      font-family: PingFangSC-Medium;
      color: #000000;
      padding-bottom 14px
    }
    .des{
      font-size: 10px;
      text-align: center;
      line-height: 18px;
      padding 0 60px
    }
    .gobtn{
      width:199px;
      height: 49px;
      text-align: center;
      color:#fff;
      background: #EB5040;
      border-radius: 24.5px;
      font-size: 14px;
      line-height: 49px;
      margin:16px auto auto;
      .icon{
        display: inline-block;
        width:16px;
        height: 11px;
        margin-left: 5px;
        background:url(../../assets/images/go-integral-icon@2x.png) no-repeat 0 0;
        background-size: cover;
      }
    }
  }
}
</style>
